import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { LoadingOverlayProps } from '../types';

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        borderRadius: 2,
      }}
    >
      <CircularProgress size={40} sx={{ color: 'primary.main', mb: 2 }} />
      <Typography variant="body1" color="text.secondary">
        Processing your request...
      </Typography>
    </Box>
  );
};

export default LoadingOverlay;
